import React, { useEffect }  from "react"
import { Link } from 'gatsby'
import styled from 'styled-components'

import SmallArrow from '../../svgs/small-arrow.svg'
import CrystalDataBall from '../../svgs/crystal-data-ball.svg'

import gsap from "gsap"
import { ScrollTrigger } from "gsap/ScrollTrigger"
import { MotionPathPlugin } from "gsap/MotionPathPlugin"

const SectionOneV2 = () => {

    useEffect(() => {

        if (typeof window !== `undefined`) {
            gsap.registerPlugin(ScrollTrigger)
            gsap.core.globals('ScrollTrigger', ScrollTrigger)
            gsap.registerPlugin(MotionPathPlugin)
            gsap.core.globals('MotionPath', MotionPathPlugin)
        }

        // box intros
        gsap.to(".h-slide-up-1", { delay: 1, duration: 1, opacity: '1', top: '0'});
        gsap.to(".h-slide-up-2", { delay: 1.1, duration: 1, opacity: '1', top: '0'});
        gsap.to(".h-slide-up-3", { delay: 1.2, duration: 1, opacity: '1', top: '0'});
        gsap.to(".h-slide-up-4", { delay: 1.3, duration: 1, opacity: '1', top: '0'});
        gsap.to(".h-slide-up-5", { delay: 1.4, duration: 1, opacity: '1', top: '0'});
        gsap.to(".h-slide-up-6", { delay: 1.5, duration: 1, opacity: '1', top: '0'});
        gsap.to(".h-slide-up-7", { delay: 1.6, duration: 1, opacity: '1', top: '0'});
        gsap.to(".h-slide-up-8", { delay: 1.7, duration: 1, opacity: '1', top: '0'});
        gsap.to(".h-slide-up-9", { delay: 1.8, duration: 1, opacity: '1', top: '0'});
        gsap.to(".home-header-main-copy", { delay: 2, duration: 1, opacity: '1', left: '0'});

        ScrollTrigger.matchMedia({
            "(min-width: 1201px)": function() {
                // red box moves and creates section title
                    
                let tlOne = gsap.timeline({
                    paused: true,
                    scrollTrigger: {
                        trigger: "#red_box_animate",
                        start: 'top 36%',
                        end: 'top 36%',
                        id: 'section_one_animate',
                        toggleActions: "play play reverse reverse",
                        },
                    })
                tlOne.to('.red-block-test', { duration: .5, ease: "power4.inOut", rotation: 405 })
                tlOne.to('.da-red-box', { duration: .1, ease: "power4.out", opacity: '1' }, 0.5)
                tlOne.to('.red-block-test', { duration: .1, opacity: '0' }, 0.6)
                tlOne.to('.da-red-box', { duration: .3, ease: "power1.inOut", bottom: '-50px', left: '0px', rotation: 180 }, 0.7)
                tlOne.to('.da-header', { duration: .1, opacity: '1' })
                tlOne.to('.da-red-box', { duration: .1, opacity: '0' })
                tlOne.to('.da-header', { maxHeight: '500px', maxWidth: '704px', padding: '50px 55px', border: '10px solid #C44C4A' })
                

                //section one animate content

                let tlTwo = gsap.timeline({
                    paused: true,
                    scrollTrigger: {
                        trigger: "#section_one_content",
                        start: 'top 36%',
                        end: 'top 36%',
                        id: 'section_one_content',
                        toggleActions: "play play reverse reverse",
                        },
                    })
                tlTwo.to('.da-content', { duration: .3, opacity: '1', top: '0' }, 0.5)
                tlTwo.to('.da-graphic', { duration: .3, opacity: '1', top: '0' }, 1)
                
            },
            "(max-width: 1200px)": function() {
                let daMobileOne = gsap.timeline({
                    paused: true,
                    scrollTrigger: {
                        trigger: "#da_mobile_one",
                        start: 'top 90%',
                        end: 'top 90%',
                        id: 'da_mobile_one',
                        toggleActions: "play play reverse reverse",
                        },
                    })
                daMobileOne.to('.da-mobile-one', { duration: .5, opacity: '1', top: '0' })

                let daMobileTwo = gsap.timeline({
                    paused: true,
                    scrollTrigger: {
                        trigger: "#da_mobile_two",
                        start: 'top 90%',
                        end: 'top 90%',
                        id: 'da_mobile_two',
                        toggleActions: "play play reverse reverse",
                        },
                    })
                daMobileTwo.to('.da-content', { duration: .5, opacity: '1', top: '0' }, 0.5)
                daMobileTwo.to('.da-graphic', { duration: .5, opacity: '1', top: '0' }, 1)

            }
        });

    }, []);

    return(
        <RedBoxAnimate id="red_box_animate">
            <HeroBox className={"hero-fix"}>
                <div class="grid-row-main">
                    <div class="main-grid">
                        <div class="grid-row">
                            <div class="red-block h-slide-up-1">
                                <div class="red-block-test"></div>
                            </div>
                            <div class="h-slide-up-2"></div>
                            <div class="h-slide-up-3"></div>
                        </div>
                        <div class="grid-row">
                            <div class="h-slide-up-4"></div>
                            <div class="h-slide-up-5"></div>
                            <div class="h-slide-up-6"></div>
                        </div>
                        <div class="grid-row">
                            <div class="h-slide-up-7"></div>
                            <div class="h-slide-up-8"></div>
                            <div class="h-slide-up-9"></div>
                        </div>
                    </div>
                    <div class="home-header-main-copy">
                        <h2>Predictive Marketing + Communications <br/>For Food + Energy Brands</h2>
                        {/* <div class="hero-links">
                            <Link to="/services/">Measurement</Link>
                            <Link to="/services/">Predictive Research</Link>
                            <Link to="/services/">Creative Design</Link>
                            <Link to="/services/">Applications</Link>
                            <Link to="/services/">Websites</Link>
                            <Link to="/services/">Newsrooms</Link>
                            <Link to="/services/">Newsmaking</Link>
                            <Link to="/services/">Paid Programmatic</Link>
                            <Link to="/services/">Social</Link>
                        </div> */}
                    </div>
                </div>
            </HeroBox>
            <MainSection id="section_one_pin">
            <div class="da-animation-path">
                <div class="da-red-box"></div>
            </div>
            <div class="top-row" id="section_one_content">
                <div class="animation-block da-mobile-one" id="da_mobile_one">
                    <div class="da-header">
                        <h2>Predictive Marketing & Communications</h2>
                    </div>
                </div>
            </div>
            <div class="bottom-row">
                <div class="da-content"  id="da_mobile_two">
                    <p>Hahn leverages data science, predictive models and wonderfully creative thinking to promote and protect food and energy brands.</p>
                    {/* <Link to="#">Learn More <SmallArrow/></Link> */}
                </div>
                <div class="da-graphic">
                    <CrystalDataBall/>
                </div>
            </div>
        </MainSection>
        </RedBoxAnimate>  
    );

}

const RedBoxAnimate = styled.div`
    margin-top: 380px;
    @media(max-width:1200px) {
        margin-top: 0px;
        width: 100%;
    }
`

const HeroBox = styled.section`
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    align-items: flex-end;
    padding-bottom: 40px;
    .grid-row-main {
        max-width: 1310px;
        width: 100%;
        margin: 0 auto;
        padding: 0 20px;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        position: relative;
        z-index: 10;
        .main-grid {
            height: 310px;
            width: 310px;
            margin-left: 60px;
            margin-right: 80px;
            display: flex;
            flex-wrap: wrap;
            align-content: space-between;
            .grid-row {
                position: relative;
                width: 100%;
                max-width: 310px;
                height: 50px;
                display: flex;
                justify-content: space-between;
                > div {
                    height: 50px;
                    width: 50px;
                    background-color: #2b2520;
                    position: relative;
                    top: 40px;
                    opacity: 0;
                    &.red-block {
                        background-color: transparent;
                    }
                    .red-block-test {
                        position: absolute;
                        top: 0;
                        left: 0;
                        width: 50px;
                        height: 50px;
                        background-color: #C44C4A;
                        &.active {
                            top: -2px;
                            transform: rotate(405deg);
                            box-shadow: 4px 4px 8px rgb(0 0 0 / 20%);
                        }
                    }
                }
            }
        }
        .home-header-main-copy {
            opacity: 0;
            position: relative;
            left: 40px;
            h2 {
                font-family: "Work Sans";
                font-size: 40px;
                font-weight: 400;
                color: #777c7c;
                margin-top: 0;
                margin-bottom: 0;
                line-height: 1.5;
            }
            .hero-links {
                width: 100%;
                max-width: 830px;
                display: flex;
                flex-wrap: wrap;
                a {
                    font-family: "Work Sans";
                    font-size: 24px;
                    font-weight: 700;
                    color: #C44C4A;
                    margin-right: 45px;
                    margin-top: 40px;
                }
            }
        }
    }
    @media(max-width: 1200px) {
        .grid-row-main {
            .main-grid {
                height: 270px;
                width: 270px;
                margin-left: 20px;
                margin-right: 60px;
            }
        }
    } 
    @media(max-width:1000px) {
        overflow: hidden;
        .grid-row-main {
            flex-wrap: wrap;
            .main-grid {
                margin: 0 auto;
                margin-bottom: 30px;
                width: 150px;
                height: 150px;
                .grid-row {
                    height: 30px;
                    > div {
                        height: 30px;
                        width: 30px;
                        .red-block-test {
                            height: 30px;
                            width: 30px;
                        }
                    }
                }
            }
            .home-header-main-copy {
                width: 100%;
                h2 {
                    text-align: center;
                }
                .hero-links {
                    max-width: 100%;
                    justify-content: center;
                    a {
                        margin-top: 20px;
                        margin-left: 20px;
                        margin-right: 20px;
                    }
                }
            }
        }
    }
    @media(max-width:767px) {
        .grid-row-main {
            .main-grid {
                display: none;
                height: 100px;
                width: 100px;
                .grid-row {
                    height: 20px;
                    > div {
                        height: 20px;
                        width: 20px;
                        .red-block-test {
                            height: 20px;
                            width: 20px;
                        }
                    }
                }
            }
            .home-header-main-copy {
                h2 {
                    font-size: 24px;
                }
                .hero-links {
                    a {
                        font-size: 18px;
                        margin-left: 10px;
                        margin-right: 10px;
                        margin-top: 10px;
                        text-align: center;
                    }
                }
            }
        }
    }
`

const MainSection = styled.section`
    position: relative;
    max-width: 1310px;
    width: 100%;
    margin: 100px auto;
    padding: 0 20px;
    display: flex;
    flex-wrap: wrap;
    .da-animation-path {
        position: absolute;
        top: -524px;
        left: 20px;
        width: 70px;
        height: 524px;
        .da-red-box {
            position: absolute;
            height: 50px;
            width: 50px;
            bottom: 400px;
            left: 60px;
            background-color: #C44C4A;
            transform: rotate(45deg);
            opacity: 0;
        }
    }
    .top-row {
        width: 100%;
        .animation-block {
            width: 704px;
            height: 384px;
        }
        .da-header {
            border: 25px solid #C44C4A;
            padding: 0;
            max-height: 0;
            max-width: 0;
            overflow: hidden;
            opacity: 0;
            h2 {
                font-family: "Nobel",sans-serif;
                font-size: 80px;
                line-height: 1.1;
                font-weight: 700;
                color: #2b2520;
                margin-top: 0;
                margin-bottom: 0px;
            }
            p {
                font-family: "Work Sans";
                font-size: 36px;
                line-height: 50px;
                font-weight: 400;
                color: #777C7C;
                margin-top: 0;
                margin-bottom: 0;
            }
        }
    }
    .bottom-row {
        width: 100%;
        display: flex;
        .da-content {
            margin-top: 100px;
            padding-left: 70px;
            max-width: 613px;
            opacity: 0;
            position: relative;
            top: 20px;
            h3 {
                font-family: "Work Sans";
                font-size: 30px;
                line-height: 36px;
                font-weight: 400;
                color: #2b2520;
                margin-top: 0;
                margin-bottom: 10px;
            }
            p {
                font-family: "Work Sans";
                font-size: 18px;
                line-height: 36px;
                font-weight: 400;
                color: #777c7c;
                margin-top: 0;
                margin-bottom: 0px;
            }
            a {
                font-family: "Work Sans";
                font-size: 20px;
                line-height: 24px;
                font-weight: 700;
                color: #2b2520;
                margin-top: 10px;
                margin-bottom: 10px;
                text-decoration: none;
                display: flex;
                justify-content: flex-start;
                align-items: center;
                transition-duration: .3s;
                svg {
                  width: 24px;
                  margin-left: 10px;
                  transition: all .3s cubic-bezier(.77,0,.175,1);
                }
                &:hover {
                  color: #C44C4A !important;
                  svg {
                    transform: translateX(10px);
                  }
                }
            }
        }
        .da-graphic {
            max-width: 547px;
            width: 100%;
            margin-top: 27px;
            margin-left: 52px;
            opacity: 0;
            position: relative;
            top: 20px;
        }
    }
    @media(max-width: 1200px) {
        .top-row {
            .da-header {
                border: 10px solid #C44C4A !important;
                padding: 35px !important;
                max-height: 100% !important;
                max-width: 100% !important;
                overflow: hidden;
                opacity: 1 !important;
                h2 {
                    font-size: 80px;
                    line-height: 1.2;
                    margin-bottom: 0px;
                }
                p {
                    font-size: 28px;
                    line-height: 1.2;
                }
            }
        }
        .bottom-row {
            .da-content {
                padding-left: 45px;
            }
        }
    }
    @media(max-width: 1000px) {
        flex-wrap: wrap;
        max-width: 700px;
        .top-row {
            width: 100%;
            .animation-block {
                height: auto;
                width: 100%;
            }
            .da-header {
                h2 {
                    font-size: 44px;
                }
                p {
                    font-size: 20px;
                }
            }
        }
        .bottom-row {
            flex-wrap: wrap;
            .da-content {
                padding-left: 0;
                max-width: 520px;
                margin: 0 auto;
                margin-top: 60px;
            }
            .da-graphic {
                max-width: 520px;
                width: 100%;
                margin: 0 auto;
                margin-top: 20px;
            }
        }
    }
    @media(max-width:767px) {
        max-width: 500px;
        width: 100%;
        overflow: hidden;
        margin: 50px auto;
        .top-row {
            .animation-block {
                width: 100%;
            }
            .da-header {
                padding: 20px !important;
                border: 5px solid #C44C4A !important;
                h2 {
                    font-size: 32px;
                }
            }
        }
        .bottom-row {
            .da-content {
                margin-top: 40px;
                h3 {
                    font-size: 24px;
                    line-height: 1.2;
                }
                p {
                    font-size: 16px;
                    line-height: 1.6;
                }
                a {
                    font-size: 18px;
                }
            }
        }
    }
`

export default SectionOneV2